<template>
  <div class="text-left">
    <label
      :for="`ulTextarea-${inputData.id}`"
      :class="{ 'is-invalid': $v.inputValue.$error }"
      v-html="addNbsp(getLocaleText(inputData.label))"
    />
    <v-textarea
      :id="`ulTextarea-${inputData.id}`"
      v-model="$v.inputValue.$model"
      flat
      solo
      auto-grow
      :placeholder="getLocaleText(inputData.placeholder)"
      rows="4"
      :class="{ 'is-valid': inputValue.length && !$v.inputValue.$invalid }"
      :error="$v.inputValue.$error"
      class="mt-2"
      hide-details="auto"
      @change="updateValue"
    >
      <template #append>
        <v-icon
          v-if="
            inputValue.length &&
            $v.inputValue.$invalid === $v.inputValue.$error &&
            $v.inputValue.$invalid === false
          "
        >
          $tick
        </v-icon>
        <v-icon
          v-if="$v.inputValue.$invalid === $v.inputValue.$error && $v.inputValue.$invalid === true"
        >
          $warning
        </v-icon>
      </template>
    </v-textarea>
  </div>
</template>

<script>
import formGtm from '@/mixins/formGtm';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'UlTextarea',
  mixins: [formGtm],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    helpText: {
      type: String,
      default: ''
    },
    errorText: {
      type: String,
      default: ''
    },
    store: {
      type: String,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    },
    formName: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      inputValue: ''
    };
  },
  validations() {
    return this.inputData.required ? { inputValue: { required } } : { inputValue: {} };
  },
  computed: {
    responses() {
      return this.$store.getters['dynamicForms/responses'];
    }
  },
  watch: {
    // local model synced with parent prop
    value: {
      immediate: true,
      handler(value) {
        const next = value === null ? '' : String(value);
        if (this.$v && this.$v.inputValue && this.$v.inputValue.$model !== next) {
          this.$v.inputValue.$model = next;
        } else {
          this.inputValue = next;
        }
      }
    },
    // validity to parent for new dynamic form flow
    '$v.inputValue.$invalid'(inv) {
      this.$emit('valid-change', !inv);
    }
  },
  created() {
    const existing = (this.formName && this.responses?.[this.formName]?.[this.inputData.id]) || '';
    if (existing) {
      this.$v.inputValue.$model = String(existing);
    }
    this.$v.$reset();
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => {
      this.validate();
    });
  },
  destroyed() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.formName) {
        this.$store.commit('dynamicForms/updateValidation', {
          id: this.inputData.id,
          value: !this.$v.$invalid,
          formName: this.formName
        });
      }
      this.$emit('valid-change', !this.$v.$invalid);
    },
    updateValue() {
      this.validate();
      const newValue = this.$v.inputValue.$model;
      if (this.formName) {
        this.$store.dispatch('dynamicForms/updateResponse', {
          id: this.inputData.id,
          value: newValue,
          formName: this.formName
        });
      }
      this.$emit('update:value', newValue);
    }
  }
};
</script>
